(function () {
    'use strict';

    angular.module('app').controller('CustomersController', CustomersController);

    CustomersController.$inject = [
        '$scope',
        '$rootScope',
        '$routeParams',
        'LoyaltyService',
        '$location',
        'LANGS',
        '$filter',
        '$timeout',
        '$q',
        '$uibModal',
        'blockUI',
        'ExportService',
        'SelectService',
        'NotifyService',
        'MessageService',
        'TransactionService',
        'POSService',
        'BusinessService',
        'CustomerService',
        'CouponsService',
        'SettingsService'];

    function CustomersController(
        $scope,
        $rootScope,
        $routeParams,
        LoyaltyService,
        $location,
        LANGS,
        $filter,
        $timeout,
        $q,
        $uibModal,
        blockUI,
        ExportService,
        SelectService,
        NotifyService,
        MessageService,
        TransactionService,
        POSService,
        BusinessService,
        CustomerService,
        CouponsService,
        SettingsService
    ) {

        var storage_query = 'pqc' + $rootScope.ENV.tools.storage_suffix;
        var storage_table_cols = 'c_cols' + $rootScope.ENV.tools.storage_suffix;
        var storage_customers_filters_set = 'cfs' + $rootScope.ENV.tools.storage_suffix;
        $scope.isInCust = appConfig.platformParams.main_site.en === 'incust.com';

        $scope.selectedUsers = {};
        $scope.selectedUsersCount = selectedUsersCount;
        $scope.getCustomerStatusDescription = getCustomerStatusDescription;
        $scope.isPhoneValid = isPhoneValid;

        $scope.customersFilters = CustomersFilters();

        $scope.isSupportUserExternalId = false;
        $scope.customerSpecialAccounts = null;
        $scope.businessSpecialAccounts = null;

        $scope.model = {};
        $scope.staff = {};

        $scope.params = {
            page: 1,
            count: 10
        };

        $scope.data = {
            genders: [
                {id: 'male', title: 'Male'},
                {id: 'female', title: 'Female'},
                {id: 'other', title: 'Other'}
            ],
            access_types: [
                {id: 'full-bonuses-access', title: 'Full access'},
                {id: 'add-bonuses-only', title: 'Add bonuses only'},
                {id: 'waiting-for-confirmation', title: 'Waiting for confirmation'},
                {id: 'in-black-list', title: 'In blacklist'}
            ],
            showAdvancedFilters: false,
            isFilePreparing: false,
            customerTypes: [
                {
                    title: 'Customer email',
                    value: 'email'
                },
                {
                    title: 'Customer phone',
                    value: 'phone'
                }
            ]
        };

        $scope.state = {
            showLimited: false
        };

        $scope.pager_count = [10, 20, 50, 100, 200];

        $scope.fieldsTypes = [
            {value: 'string', text: 'String'},
            {value: 'date', text: 'Date'},
            {value: 'integer', text: 'Number'},
            {value: 'dictionary', text: 'Dictionary'}
        ];

        $scope.table_cols_preset = [
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'user_phone', text: 'Customer number', visible: true},
                    {value: 'user_email', text: 'Customer email', visible: true},
                    {value: 'user_status', text: 'Status', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'access_type', text: 'Access type', visible: true},
                    {value: 'card_category_title', text: 'Card category', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'sale_count', text: 'Sales count', visible: true},
                    {value: 'transactions_amount', text: 'Transaction amount', visible: true},
                    {value: 'average_cheque', text: 'Average cheque', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'bonuses_added', text: 'Bonuses added', visible: true},
                    {value: 'bonuses_redeemed', text: 'Bonuses redeemed', visible: true},
                    {value: 'bonuses_on_hand', text: 'Bonuses on hand', visible: true},
                    {value: 'transactions_discount_amount', text: 'Discount amount', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'first_transaction_dt', text: 'first_transaction_date', visible: true},
                    {value: 'first_transaction_days_from', text: 'first_transaction_days_from', visible: true},
                    {value: 'first_sale_transaction_dt', text: 'first_sale_transaction_date', visible: true},
                    {
                        value: 'first_sale_transaction_days_from',
                        text: 'first_sale_transaction_days_from\   ',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'last_transaction_dt', text: 'last_transaction_date', visible: true},
                    {value: 'last_transaction_days_from', text: 'last_transaction_days_from', visible: true},
                    {value: 'last_sale_transaction_dt', text: 'last_sale_transaction_date', visible: true},
                    {value: 'last_sale_transaction_days_from', text: 'last_sale_transaction_days_from', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'customer_additional_cards', text: 'Additional cards', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'user_name', text: 'Customer name', visible: true},
                    {value: 'user_gender', text: 'Gender', visible: true},
                    {value: 'user_birth_date', text: 'Birthday', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'user_country', text: 'Country', visible: true},
                    {value: 'user_language', text: 'Language', visible: true}
                ]
            },
            {
                visible: true,
                exportOnly: false,
                data: [
                    {value: 'user_mobile_client_in_use', text: 'Using mobile app', visible: true}
                ]
            },
            {
                visible: false,
                exportOnly: true,
                data: [
                    {value: 'special_accounts', text: 'Customer accounts', visible: false},
                ]
            }
        ];
        $scope.searchCustomerType = {
            selected: angular.copy($scope.data.customerTypes[0])
        };
        $scope.searchCustomerValue = {
            phone: '',
            email: '',
            external_id: ''
        };
        $scope.conditionsList = {};

        $scope.LANGS = LANGS;
        $scope.summary = {};
        $scope.getFiltersList = SelectService.getLPRList;
        // $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getCustomers = getCustomers;
        $scope.filterHelper = {};
        $scope.makeFieldsList = $scope.customersFilters.getUIList;

        $scope.popupSendMessage = popupSendMessage;
        $scope.popupSendNotify = popupSendNotify;
        $scope.popupAddBonuses = popupAddBonuses;
        $scope.popupWriteOffBonuses = popupWriteOffBonuses;
        $scope.popupBalanceAdjustmentBonuses = popupBalanceAdjustmentBonuses;
        $scope.popupRefillSpecialAccount = popupRefillSpecialAccount;
        $scope.popupWriteOffSpecialAccount = popupWriteOffSpecialAccount;
        $scope.popupBalanceAdjustmentSpecialAccount = popupBalanceAdjustmentSpecialAccount;
        $scope.popupCardCategory = popupCardCategory;
        $scope.popupChangeAccessType = popupChangeAccessType;
        $scope.popupGiveCouponToCustomers = popupGiveCouponToCustomers;

        $scope.getPages = getTotalPaginatedPages;

        $scope.isPageMode = isPageMode;
        $scope.isModifyDenied = isModifyDenied;
        $scope.isConsentExist = isConsentExist;
        $scope.isConsentRequired = isConsentRequired;

        // $scope.date_picker = {
        //     opened: false
        // };
        $scope.currentTab = 'edit-customer';
        $scope.model.inlineMessage = '';

        $scope.isPOSActive = function (pos_id) {
            var p = null;
            if ($rootScope.POS) {
                p = itemByIndex($rootScope.POS, pos_id);

                return p && p.active;
            }

            return true;
        };

        $scope.isLoyaltyActive = function (pos_id) {
            var l = null;
            var p = null;
            if ($rootScope.POS) {
                p = itemByIndex($rootScope.POS, pos_id);
                if ($rootScope.LOYALTIES && p) {
                    l = itemByIndex($rootScope.LOYALTIES, p.loyalty_id);
                    return l && l.active;
                }
            }

            return true;
        };

        var block_clients_list = blockUI.instances.get('clients_list'),
            block_fields_list = blockUI.instances.get('fields_list'),
            block_find_customer = blockUI.instances.get('find_customer'),
            block_customer_special_account_table = blockUI.instances.get('customer-special-account-table'),
            block_edit_client = blockUI.instances.get('edit_client');

        var cutomersTimeout, categoriesTimeout;

        //var getCustomersInProcessFrom = null;
        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    $scope.table_cols_preset[0].data.splice(($scope.table_cols_preset[0].data.length - 1), 0, {
                        value: 'user_external_id',
                        text: 'Customer external id',
                        visible: true,
                        not_sortable: true
                    });

                    $scope.data.customerTypes.push({
                        title: 'Customer external id',
                        value: 'external-id'
                    });

                }
            }


            initController();
        });
        $scope.phoneValidInFindCustomer = false;
        $scope.onPhoneChangeInFindCustomer = function () {
            if ($scope.searchCustomerValue.phone && isPhoneValid($scope.searchCustomerValue.phone))
                $scope.phoneValidInFindCustomer = true;
            else
                $scope.phoneValidInFindCustomer = false;
        };

        $scope.findCustomerNotFound = false;
        $scope.findCustomer = function () {

            if (!$scope.searchCustomerType || !$scope.searchCustomerType.selected.value) {
                return;
            }

            var params = {};

            var cf = angular.copy($scope.data.currentFilter);

            if (cf.filter_list_type === 'loyalty') {
                params.loyalty_id = cf.id;
            } else if (cf.filter_list_type === 'pos') {
                params.loyalty_id = cf.loyalty_id;
                params.pos_id = cf.id;
            }
            switch ($scope.searchCustomerType.selected.value) {
                case 'phone':
                    params.user_id_type = 'phone';
                    params.user_id_value = $scope.searchCustomerValue.phone;
                    break;
                case 'email':
                    params.user_id_type = 'email';
                    params.user_id_value = $scope.searchCustomerValue.email;
                    break;
                case 'external-id':
                    params.user_id_type = 'external-id';
                    params.user_id_value = $scope.searchCustomerValue.external_id;
                    break;
            }
            $scope.findCustomerNotFound = false;
            block_find_customer.start();
            CustomerService.BusinessCustomerByType(params.loyalty_id, params.user_id_type, params.user_id_value, function (success, data) {
                if (success) {
                    $scope.popupCustomerDetail(data, true);
                } else {
                    $scope.findCustomerNotFound = true;
                }
                block_find_customer.stop();
            });
        };
        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************
        $scope.onChangeTab = function (tab) {

            if(isPageMode('create')) {
                confirmationCreatePopup($scope.form, tab);
                return;
            }

            if (tab === 'special-accounts') {
                refreshCustomerSpecialAccounts();
            }

            $scope.currentTab = tab;
            $location.url($location.$$path + '?tab=' + tab);
        };

        $scope.formInit = function (formRef) {
            $scope.form = formRef;
        };

        function confirmationCreatePopup(form, tab) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type = 'customer';

                    popup.onSaveClick = function (exit) {
                        if (form.$valid) {
                            $scope.onSaveCustomer(form, true);
                            $scope.data.currentTab = tab;
                            $location.search('tab', tab);
                        } else {
                            isFormValid(form);
                        }

                        $uibModalInstance.close();
                    };

                    popup.onCancelClick = function (exit) {
                        isFormValid(form);
                        $uibModalInstance.close();
                    };
                }
            });
        }

        /**
         * Page mode display differed parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../pos/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('customer_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';

            if (isRouteMode('fields')) $scope._pageMode = 'fields';
        }

        function initController() {
            initPageMode();
            $rootScope.getBusinessSettings();
            BusinessService.SpecialAccounts(function (success, data) {
                if (success) {
                    $scope.businessSpecialAccounts = data.filter(function (acc) {
                        return acc.active;
                    })
                }

            })
            var _cols = $rootScope.paramsQueryGet(storage_table_cols);
            if (!_cols) {
                initTableColumns();
            }

            block_fields_list.start();
            CustomerService.CustomerFields(function (success, data) {
                if (success) {
                    $scope.customersFilters.addCustomerFields($rootScope.CUSTOMER_FIELDS);
                    $scope.customerFields = $rootScope.CUSTOMER_FIELDS;

                    $scope.customersFilters.getUITreeList({}, function (conditions_list) {
                        $scope.conditionsList = conditions_list;
                    }, $scope.isSupportUserExternalId);

                    switch ($scope._pageMode) {
                        case 'create':
                            doCreate();

                            break;

                        case 'show':
                            doShow();
                            break;

                        case 'fields':
                            doEditFields();
                            break;

                        case 'edit':
                            doEdit();
                            break;
                    }
                }
                block_fields_list.stop();
            });

        }

        /**
         * Return custom field name for SQL query
         * @param name
         */
        function customFieldSQLName(name) {
            if ((name.indexOf('-') > 0 || $scope.customersFilters.staticFieldsIds.indexOf(name) === -1) &&
                name.indexOf('bcf_') === -1 &&
                name !== 'card_category_title')
                return 'bcf_{0}_value'.format(name.replace(/[-]*/g, ''));
            else
                return name;
        }

        /**
         * Return selected users count
         */
        function selectedUsersCount() {
            var result = 0;
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i])
                    result += 1;
            }
            return result;
        }

        /**
         * Return array with ID of only selected users
         */
        function selectedUsersToArray() {
            var result = [];
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i]) result.push(i);
            }
            return result;
        }

        /**
         * Return TRUE if any user selected
         * @returns {boolean}
         */
        function existSelectedUsers() {
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i]) return true;
            }
            return false;
        }

        /**
         * Check is consent required (mandatory)
         */
        function isConsentRequired() {

            if ($rootScope.ENV.business.settings && $rootScope.ENV.business.settings.consent_request_required) {
                return true;
            } else {
                return false;
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Show customers
         */
        function doShow() {
            $scope.field_type_and = 'user_phone';
            $scope.field_type_or = 'user_phone';

            getSavedQuery();

            function s() {
                if ($scope.data.currentFilter) {

                    if ($rootScope.ENV.business.tariff.use_advanced_customer_filters)
                        $rootScope.TARIFF_LIMITATION.use_advanced_customer_filters = false;
                    else
                        $rootScope.TARIFF_LIMITATION.use_advanced_customer_filters = true;

                    getCustomers();
                } else {
                    $timeout(s, 250);
                }
            }

            s();

        }

        function initTableColumns() {
            $scope.table_cols = angular.copy($scope.table_cols_preset);
            $rootScope.paramsQueryStore(storage_table_cols, $scope.table_cols);
        }

        function getSavedQuery() {
            var _cols = $rootScope.paramsQueryGet(storage_table_cols);
            if (_cols) {
                $scope.table_cols = _cols;
            } else {
                initTableColumns();
            }

            var q = $rootScope.paramsQueryGet(storage_query);
            if (q) {
                $scope.params = {
                    loyalty_id: q.loyalty_id,
                    page: 1,
                    count: q.count
                };

                if (q.sort) {
                    $scope.params.sort_field = q.sort.split(' ')[0];
                    $scope.params.sort_direction = q.sort.split(' ')[1];
                }

                // if (q.conditions) {
                //     $scope.data.showAdvancedFilters = true;
                //     $scope.params.conditions = q.conditions;
                //     $scope.customersFilters.toObject(q.conditions);
                // }
            }

            var cfs = $rootScope.paramsQueryGet(storage_customers_filters_set);
            if (cfs) {
                $scope.data.showAdvancedFilters = true;
                $scope.customersFilters.setCurrentSet(cfs);
                $scope.params.conditions = $scope.customersFilters.toQuery();
            }
        }

        /**
         * Send to server query for get transactions
         */
        function getCustomers() {
            // var CURR_TIME = new Date();
            // if (getCustomersInProcessFrom && (CURR_TIME - getCustomersInProcessFrom) < 180) {
            //     console.warn("Previous getCustomers() in process. Skip.");
            //     return;
            // } else {
            //     getCustomersInProcessFrom = CURR_TIME;
            // }

            block_clients_list.start();

            var cf = $scope.data.currentFilter,
                params = {
                    page: $scope.params.page,
                    count: $scope.params.count,
                    conditions: $scope.params.conditions ? $scope.params.conditions : $scope.customersFilters.toQuery()
                };

            if (cf.filter_list_type === 'loyalty') {
                params.loyalty_id = cf.id;
            } else if (cf.filter_list_type === 'pos') {
                params.loyalty_id = cf.loyalty_id;
                params.pos_id = cf.id;
            }
            if ($scope.params.sort_field && $scope.params.sort_direction)
                params.sort = '{0} {1}'.format(customFieldSQLName($scope.params.sort_field), $scope.params.sort_direction);

            if (!params.conditions) {
                delete params.conditions;
                $scope.data.showAdvancedFilters = false;
            }

            params.slow_request = true;

            $rootScope.paramsQueryStore(storage_customers_filters_set, $scope.customersFilters.getCurrentSet());

            function handleResults(success, data) {
                if (success) {
                    $rootScope.paramsQueryStore(storage_query, params);

                    $scope.customers = angular.copy(data.data);
                    $scope.customers.forEach(function (item) {
                        item.id = item.user_id;
                    });

                    $scope.summary = data.summary;
                } else {
                    $rootScope.paramsQueryClean(storage_query);
                }
                block_clients_list.stop();
                // getCustomersInProcessFrom = null;
            }

            CustomerService.All(params, handleResults);
        }

        function getCardCategories(lid, callback) {
            LoyaltyService.CardCategories(lid, function (success, data) {
                if (success) {
                    $scope.cardCategories = data;
                }
                callback(success, data);
            });
        }

        $scope.onColumnsReset = function () {
            initTableColumns();
        };

        $scope.onColumnAdd = function (first) {
            if (first)
                $scope.table_cols.unshift({visible: true, data: []});
            else
                $scope.table_cols.push({visible: true, data: []});
        };

        $scope.onColumnRemove = function (index) {
            $scope.table_cols.splice(index, 1);
            // $rootScope.paramsQueryStore(storage_table_cols, $scope.table_cols);
        };

        $scope.onColumnDisplayChange = function (index) {
            for (var i in $scope.table_cols[index].data)
                $scope.table_cols[index].data[i].visible = $scope.table_cols[index].visible;

            // $rootScope.paramsQueryStore(storage_table_cols, $scope.table_cols);
        };

        $scope.onColumnDataDisplayChange = function (index) {
            $scope.table_cols.forEach(function (column) {
                column.visible = column.data.some(function (data) {
                    return data.visible;
                });
            });
        };

        // $scope.$watch('table_cols', function(newValue, oldValue, scope) {
        //     if(newValue)
        //         $rootScope.paramsQueryStore(storage_table_cols, newValue);
        // }, true);

        /**
         * Return value of customer custom field
         * @param customer
         * @param field
         */
        $scope.getCustomFieldValue = function (customer, field) {
            if (customer[customFieldSQLName(field.id)])
                return customer[customFieldSQLName(field.id)];
            else
                return '-';
        };

        /**
         * Show or hide block with filters
         * @param isShow
         */
        /**
         * Select all checkboxes
         */
        $scope.onSelectAllUsers = function () {
            for (var i in $scope.customers)
                $scope.selectedUsers[$scope.customers[i].id] = !$scope.model.selectedAll;
        };

        // *********************************************************************************************
        //  POPUP-s PART
        // *********************************************************************************************

        /**
         * Show main customer detail data in popup
         */
        $scope.popupCustomerDetail = function (customer, fullCustomer) {
            $scope.userDetailInstance = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                templateUrl: 'app/pages/customers/modals/modal.customer.detail.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = customer;
                    popup.isSupportUserExternalId = $scope.isSupportUserExternalId;
                    popup.customerFields = $rootScope.CUSTOMER_FIELDS;

                    if (!fullCustomer) {
                        CustomerService.BusinessCustomer(customer.user_id, customer.loyalty_id, function (success, data) {
                            popup.model = data;
                        });
                    }

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };

                    popup.onCustomerEdit = function (id, loyalty_id, tab) {
                        $uibModalInstance.close();
                        // onEditCustomer(id, loyalty_id);
                        if (!tab) {
                            tab = 'edit-customer';
                        }
                        $location.path(('/customers/edit/{0}/{1}').format(id, loyalty_id)).search({tab: tab});
                    };

                    popup.onViewExternalForms = function (user_id, loyalty_id) {
                        $uibModalInstance.close();
                        $location.path(('/external-forms')).search({loyalty_id: loyalty_id, user_id: user_id});
                    };

                    popup.onSendPersonalMessage = function () {
                        $uibModalInstance.close();
                        popupSendMessage(popup.model);
                    };

                    popup.onSendPersonalNotify = function () {
                        $uibModalInstance.close();
                        popupSendNotify(popup.model);
                    };

                    popup.onAddPersonalBonuses = function () {
                        $uibModalInstance.close();
                        popupAddBonuses(popup.model);
                    };

                    popup.onWriteOffPersonalBonuses = function () {
                        $uibModalInstance.close();
                        popupWriteOffBonuses(popup.model);
                    };

                    popup.onBalanceAdjustmentBonuses = function () {
                        $uibModalInstance.close();
                        popupBalanceAdjustmentBonuses(popup.model);

                    };

                    popup.onRefillSpecialAccountPersonal = function () {
                        $uibModalInstance.close();
                        popupRefillSpecialAccount(popup.model);
                    };

                    popup.onWriteOffSpecialAccount = function () {
                        $uibModalInstance.close();
                        popupWriteOffSpecialAccount(popup.model);
                    };

                    popup.onBalanceAdjustmentSpecialAccount = function () {
                        $uibModalInstance.close();
                        popupBalanceAdjustmentSpecialAccount(popup.model);
                    };

                    popup.onChangeAccessType = function () {
                        $uibModalInstance.close();
                        popupChangeAccessType(popup.model);
                    };

                    popup.onGiveCouponToCustomers = function () {
                        $uibModalInstance.close();
                        popupGiveCouponToCustomers(popup.model);
                    };
                    popup.toTransactions = function (user_id, special_account_id) {
                        $uibModalInstance.close();
                        if (special_account_id) {
                            $location.path('/transactions').search({
                                user_id: user_id,
                                special_account_id: special_account_id
                            });
                        } else {
                            $location.path('/transactions').search({user_id: user_id});
                        }

                    };
                    popup.toMessages = function (user_id, special_account_id) {
                        $uibModalInstance.close();
                        if (special_account_id) {
                            $location.path('/messages').search({
                                user_id: user_id,
                                special_account_id: special_account_id
                            });
                        } else {
                            $location.path('/messages').search({user_id: user_id});
                        }

                    };
                    popup.getCustomFieldTitle = function (field) {
                        var id = field.substring(4, field.length - 6);
                        var Field = itemByIndex(popup.customerFields, id);

                        return '{0}'.format(Field.description);
                    };

                    popup.getCustomFieldValue = function (field) {
                        return popup.model[customFieldSQLName(field)];
                    };

                    popup.getCustomerStatusDescription = $scope.getCustomerStatusDescription;
                }
            });
        };

        /**
         * Show popup for change card category
         */
        function popupCardCategory() {
            $scope.modalCardCategory = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.cardcategory.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};

                    popup.data = {};

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';

                    getCardCategories($scope.filterHelper.id, function (success, response) {
                        if (success) {
                            popup.data.cardCategories = response;

                            if (popup.data.cardCategories.length > 0) {
                                popup.model.card_category_id = popup.data.cardCategories[0].id;
                                popup.data.cardCategories = popup.data.cardCategories.filter(function (category) {
                                    return !!category.active;
                                });
                            }

                        }
                    });

                    popup.getCategoryTitle = function (category_id) {
                        if (popup.data.cardCategories)
                            return itemByIndex(popup.data.cardCategories, category_id).title;
                    };

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                loyalty_id: $scope.filterHelper.id,
                                category_id: popup.model.card_category_id
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos')
                                post_data.pos_id = $scope.data.currentFilter.id;

                            popup.model.chunk_size = 50;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            if (popup.sendTo == 'all') {
                                //    getSavedQuery();
                                post_data.conditions = angular.copy($scope.customersFilters.toQuery());
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, CustomerService.CardCategoryAssignToUser, $uibModalInstance, {update_user_list: true});
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, CustomerService.CardCategoryAssignToUser, $uibModalInstance, {update_user_list: true});
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        /**
         * Show popup for change customer access type
         */
        function popupChangeAccessType() {
            $scope.modalChangeAccessType = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.accesstype.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';

                    popup.model = {
                        loyalty_id: $scope.filterHelper.id,
                        access_type: 'full-bonuses-access'
                    };

                    popup.data = {
                        access_types: $scope.data.access_types
                    };

                    // popup.getAccessTitle = function (value) {
                    //     for (var i in popup.data.access_types)
                    //         if (popup.data.access_types[i].id === value)
                    //             return popup.data.access_types[i].i;
                    // };

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                loyalty_id: popup.model.loyalty_id,
                                access_type: popup.model.access_type
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos')
                                post_data.pos_id = $scope.data.currentFilter.id;

                            $scope.sendingResult = {
                                error_log: []
                            };

                            popup.model.chunk_size = 50;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            if (popup.sendTo == 'all') {
                                getSavedQuery();
                                post_data.conditions = $scope.customersFilters.toQuery();
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, CustomerService.AccessToAccount, $uibModalInstance, {update_user_list: true});
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, CustomerService.AccessToAccount, $uibModalInstance, {update_user_list: true});
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        /**
         * Load new list card categories depended current loyalty
         */
        function updateCardCategoriesControl(loyalty_id) {
            if ($scope.filterHelper.id) {
                LoyaltyService.CardCategories(loyalty_id ? loyalty_id : $scope.filterHelper.id, function (success, response) {
                    if (success) {
                        $scope.staff.categories = response;
                        if ($scope.isPageMode('create')) {
                            response.forEach(function (item) {
                                if (item.type == 'base') {
                                    $scope.model.card_category_id = item.id;
                                }
                            });
                        }
                    }

                    $timeout.cancel(categoriesTimeout);
                });
            } else {
                categoriesTimeout = $timeout(updateCardCategoriesControl, 250);
            }
        }

        $scope.updateCardCategoriesControl = updateCardCategoriesControl;

        /**
         * Show popup for add user bonuses
         */
        function popupAddBonuses(customer) {
            console.info('popupAddBonuses', customer);

            $scope.modalAddBonuses = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.addbonuses.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        expire_date: moment().add(1, 'month').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                        starting_date: moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                        refill_now: true
                    };

                    popup.data = {};

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();

                    if (customer) {
                        popup.user = customer;
                        popup.sendTo = 'user';
                    } else {
                        popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                    }

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.terminalNames = '';
                    SelectService.getRegistersList(function (success, response) {
                        if (success) {
                            // popup.data.registersList = response;
                            popup.data.registersList = [];
                            for (var i in response) {
                                var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                    popup.data.registersList.push(response[i]);
                            }

                            if (popup.data.registersList.length > 0) {
                                popup.model.terminal_id = popup.data.registersList[0].id;
                                popup.terminalNames = getTerminalsNames(popup.data.registersList);
                            }
                        }
                    });

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                loyalty_id: $scope.filterHelper.id,
                                terminal_id: popup.model.terminal_id,
                                comment: popup.model.comment,
                                message: popup.model.message,
                                amount: popup.model.bonuses,
                                amount_decimal_digits: 2,
                                bonuses_decimal_digits: 2,
                                special_accounts_decimal_digits: 2
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos')
                                post_data.pos_id = $scope.data.currentFilter.id;

                            $scope.sendingResult = {
                                error_log: []
                            };

                            if (popup.model.show_expiration) {
                                post_data.expire = moment(popup.model.expire_date).format('YYYY-MM-DD');
                            }

                            if (!popup.model.refill_now) {
                                post_data.starting = moment(popup.model.starting_date).format('YYYY-MM-DD');
                            }

                            popup.model.chunk_size = 25;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            var processRequestOptions = {
                                update_user_list: true,
                                error_log: true,
                                callbackOnSuccess: function () {
                                    NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_REFILL_BONUSES'), false);
                                }
                            };

                            popup.model.request_progress = 0.1;
                            if (popup.sendTo == 'all') {
                                getSavedQuery();
                                post_data.conditions = $scope.customersFilters.toQuery();
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, TransactionService.AddBonuses, $uibModalInstance, processRequestOptions);
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, TransactionService.AddBonuses, $uibModalInstance, processRequestOptions);
                            } else if (popup.sendTo == 'user') {
                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, TransactionService.AddBonuses, $uibModalInstance, processRequestOptions);
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        function confirmationPopup(type_confirmation, callbackDone) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/customers/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type_confirmation = type_confirmation;

                    popup.onDoneClick = function () {
                        $uibModalInstance.close();
                        if (callbackDone) {
                            callbackDone();
                        }
                    };

                    popup.onBonusBalanceAdjustment = function () {
                        $uibModalInstance.close();
                        $scope.popupBalanceAdjustmentBonuses();
                    };

                    popup.onSpecialAccountAdjustment = function () {
                        $uibModalInstance.close();
                        $scope.popupBalanceAdjustmentSpecialAccount();
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        function getTerminalsNames(terminals) {
            var terminalNames = '';
            if (terminals.length === 1) {
                terminalNames = terminals[0].title + (terminals[0].phone ? (' (' + terminals[0].phone + ')') : '');
            } else {
                terminals.forEach(function (terminal) {
                    terminalNames += terminal.title + (terminal.phone ? (' (' + terminal.phone + '), ') : ', ');
                });
                terminalNames = terminalNames.slice(0, -2);
            }
            return terminalNames;
        }

        function popupWriteOffBonuses(customer) {
            console.info('WriteOffBonuses', customer);

            confirmationPopup('WriteOffBonuses', function () {
                $scope.modalWriteOffBonuses = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.write-off-bonuses.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {
                            expire_date: moment().add(1, 'month').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                            expire_time: moment().endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                        };

                        popup.data = {};

                        popup.usersCount = $scope.summary.total_rows_count;
                        popup.selectedCount = $scope.selectedUsersCount();

                        if (customer) {
                            popup.user = customer;
                            popup.sendTo = 'user';
                        } else {
                            popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                        }

                        popup.terminalNames = '';
                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                // popup.data.registersList = response;
                                popup.data.registersList = [];
                                for (var i in response) {
                                    var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                    if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                    loyalty_id: $scope.filterHelper.id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.bonuses,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                if ($scope.data.currentFilter.filter_list_type === 'pos')
                                    post_data.pos_id = $scope.data.currentFilter.id;

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                if (popup.model.show_expiration) {
                                    post_data.expire = moment(popup.model.expire_date).format('YYYY-MM-DD');
                                }

                                popup.model.chunk_size = 25;

                                popup.model.users = selectedUsersToArray();
                                popup.model.total_elements = popup.model.users.length;

                                popup.model.request_progress = 0.1;

                                var processRequestOptions = {
                                    update_user_list: true,
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_WRITE_OFF_BONUSES'), false);
                                    }
                                };

                                if (popup.sendTo == 'all') {
                                    getSavedQuery();
                                    post_data.conditions = $scope.customersFilters.toQuery();
                                    CustomerService.AllIds(post_data, function (success, response) {
                                        popup.model.users = response;
                                        popup.model.total_elements = popup.model.users.length;
                                        processRequest(popup, post_data, TransactionService.WriteOffsBonuses, $uibModalInstance, processRequestOptions);
                                    });
                                } else if (popup.sendTo == 'selected') {
                                    processRequest(popup, post_data, TransactionService.WriteOffsBonuses, $uibModalInstance, processRequestOptions);
                                } else if (popup.sendTo == 'user') {
                                    popup.model.users = [popup.user.user_id];
                                    processRequest(popup, post_data, TransactionService.WriteOffsBonuses, $uibModalInstance, processRequestOptions);
                                }

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });

        }

        function popupBalanceAdjustmentBonuses(customer) {
            console.info('popupBalanceAdjustmentBonuses', customer);
            confirmationPopup('BalanceAdjustmentBonuses', function () {
                $scope.modalBalanceAdjustmentBonuses = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.balance-adjustment-bonuses.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {
                            expire_date: moment().add(1, 'month').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                            starting_date: moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                            refill_now: true
                        };

                        popup.data = {};

                        popup.usersCount = $scope.summary.total_rows_count;
                        popup.selectedCount = $scope.selectedUsersCount();

                        if (customer) {
                            popup.user = customer;
                            popup.sendTo = 'user';
                        } else {
                            popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                        }

                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        popup.terminalNames = '';
                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                // popup.data.registersList = response;
                                popup.data.registersList = [];
                                for (var i in response) {
                                    var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                    if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                    loyalty_id: $scope.filterHelper.id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.bonuses,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                if ($scope.data.currentFilter.filter_list_type === 'pos')
                                    post_data.pos_id = $scope.data.currentFilter.id;

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                if (popup.model.show_expiration) {
                                    post_data.expire = moment(popup.model.expire_date).format('YYYY-MM-DD');
                                }

                                if (!popup.model.refill_now) {
                                    post_data.starting = moment(popup.model.starting_date).format('YYYY-MM-DD');
                                }

                                popup.model.chunk_size = 25;

                                popup.model.users = selectedUsersToArray();
                                popup.model.total_elements = popup.model.users.length;

                                popup.model.request_progress = 0.1;

                                var processRequestOptions = {
                                    update_user_list: true,
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_ADJUSTMENT_BONUSES'), false);
                                    }
                                };

                                if (popup.sendTo == 'all') {
                                    getSavedQuery();
                                    post_data.conditions = $scope.customersFilters.toQuery();
                                    CustomerService.AllIds(post_data, function (success, response) {
                                        popup.model.users = response;
                                        popup.model.total_elements = popup.model.users.length;
                                        processRequest(popup, post_data, TransactionService.AdjustBonuses, $uibModalInstance, processRequestOptions);
                                    });
                                } else if (popup.sendTo == 'selected') {
                                    processRequest(popup, post_data, TransactionService.AdjustBonuses, $uibModalInstance, processRequestOptions);
                                } else if (popup.sendTo == 'user') {
                                    popup.model.users = [popup.user.user_id];
                                    processRequest(popup, post_data, TransactionService.AdjustBonuses, $uibModalInstance, processRequestOptions);
                                }

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });
        }

        /**
         * Show popup for special account refil
         */
        function popupRefillSpecialAccount(customer, options, callback) {
            console.info('popupRefillSpecialAccount', options);
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.refillspecialaccount.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};
                    popup.data = {};

                    if (options && options.special_account_id) {
                        popup.model.special_account_id = options.special_account_id;
                    }

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    if (customer) {
                        popup.user = customer;
                        popup.sendTo = 'user';
                    } else {
                        popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                    }

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.terminalNames = '';
                    SelectService.getRegistersList(function (success, response) {
                        if (success) {
                            // popup.data.registersList = response;
                            popup.data.registersList = [];
                            for (var i in response) {
                                var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                    popup.data.registersList.push(response[i]);
                            }

                            if (popup.data.registersList.length > 0) {
                                popup.model.terminal_id = popup.data.registersList[0].id;
                                popup.terminalNames = getTerminalsNames(popup.data.registersList);
                            }
                        }
                    });

                    SelectService.getSpecialAccountsListCB(function (success, response) {
                        if (success) {
                            popup.data.accountsList = [];
                            for (var i in response)
                                if (response[i].active === 1)
                                    popup.data.accountsList.push(response[i]);

                            if (popup.data.accountsList.length > 0 && !popup.model.special_account_id)
                                popup.model.special_account_id = popup.data.accountsList[0].id;

                        }
                    });

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                loyalty_id: $scope.filterHelper.id,
                                special_account_id: popup.model.special_account_id,
                                terminal_id: popup.model.terminal_id,
                                comment: popup.model.comment,
                                message: popup.model.message,
                                amount: popup.model.charge_amount,
                                amount_decimal_digits: 2,
                                bonuses_decimal_digits: 2,
                                special_accounts_decimal_digits: 2
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos')
                                post_data.pos_id = $scope.data.currentFilter.id;

                            $scope.sendingResult = {
                                error_log: []
                            };

                            popup.model.chunk_size = 25;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            var processRequestOptions = {
                                update_user_list: true,
                                error_log: true,
                                callbackOnSuccess: function () {
                                    NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_REFILL_SPECIAL_ACCOUNT'), false);
                                }
                            };

                            if (popup.sendTo == 'all') {
                                getSavedQuery();
                                post_data.conditions = $scope.customersFilters.toQuery();
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, TransactionService.RefillSpecialAccounts, $uibModalInstance, processRequestOptions);
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, TransactionService.RefillSpecialAccounts, $uibModalInstance, processRequestOptions);
                            } else if (popup.sendTo == 'user') {
                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, TransactionService.RefillSpecialAccounts, $uibModalInstance, processRequestOptions);
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onShowSpecialAccounts = function () {
                        $uibModalInstance.close();
                        $location.path('/client-accounts');
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        function popupWriteOffSpecialAccount(customer) {
            console.info('popupWriteOffSpecialAccount', customer);

            confirmationPopup('WriteOffSpecialAccount', function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.write-off-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {};
                        popup.data = {};

                        popup.usersCount = $scope.summary.total_rows_count;
                        popup.selectedCount = $scope.selectedUsersCount();
                        if (customer) {
                            popup.user = customer;
                            popup.sendTo = 'user';
                        } else {
                            popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                        }

                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        popup.terminalNames = '';

                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                // popup.data.registersList = response;
                                popup.data.registersList = [];
                                for (var i in response) {
                                    var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                    if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        SelectService.getSpecialAccountsListCB(function (success, response) {
                            if (success) {
                                popup.data.accountsList = [];
                                for (var i in response)
                                    if (response[i].active === 1)
                                        popup.data.accountsList.push(response[i]);

                                if (popup.data.accountsList.length > 0)
                                    popup.model.special_account_id = popup.data.accountsList[0].id;

                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                    loyalty_id: $scope.filterHelper.id,
                                    special_account_id: popup.model.special_account_id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.charge_amount,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                if ($scope.data.currentFilter.filter_list_type === 'pos')
                                    post_data.pos_id = $scope.data.currentFilter.id;

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                popup.model.chunk_size = 25;

                                popup.model.users = selectedUsersToArray();
                                popup.model.total_elements = popup.model.users.length;

                                popup.model.request_progress = 0.1;
                                var processRequestOptions = {
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_WRITE_OFF_SPECIAL_ACCOUNT'), false);
                                    }
                                };
                                if (popup.sendTo == 'all') {
                                    getSavedQuery();
                                    post_data.conditions = $scope.customersFilters.toQuery();
                                    CustomerService.AllIds(post_data, function (success, response) {
                                        popup.model.users = response;
                                        popup.model.total_elements = popup.model.users.length;
                                        processRequest(popup, post_data, TransactionService.WriteOffSpecialAccounts, $uibModalInstance, processRequestOptions);
                                    });
                                } else if (popup.sendTo == 'selected') {
                                    processRequest(popup, post_data, TransactionService.WriteOffSpecialAccounts, $uibModalInstance, processRequestOptions);
                                } else if (popup.sendTo == 'user') {
                                    popup.model.users = [popup.user.user_id];
                                    processRequest(popup, post_data, TransactionService.WriteOffSpecialAccounts, $uibModalInstance, processRequestOptions);
                                }

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onShowSpecialAccounts = function () {
                            $uibModalInstance.close();
                            $location.path('/client-accounts');
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });

        }

        function popupBalanceAdjustmentSpecialAccount(customer) {
            console.info('popupBalanceAdjustmentSpecialAccount', customer);
            confirmationPopup('AdjustmentSpecialAccount', function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.adjustment-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {};
                        popup.data = {};

                        popup.usersCount = $scope.summary.total_rows_count;
                        popup.selectedCount = $scope.selectedUsersCount();
                        if (customer) {
                            popup.user = customer;
                            popup.sendTo = 'user';
                        } else {
                            popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                        }

                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        popup.terminalNames = '';
                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                // popup.data.registersList = response;
                                popup.data.registersList = [];
                                for (var i in response) {
                                    var active = $scope.isPOSActive(response[i].pos_id) && $scope.isLoyaltyActive(response[i].pos_id);
                                    if (response[i].loyalty_id === $scope.filterHelper.id && response[i].active === 1 && active)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        SelectService.getSpecialAccountsListCB(function (success, response) {
                            if (success) {
                                popup.data.accountsList = [];
                                for (var i in response)
                                    if (response[i].active === 1)
                                        popup.data.accountsList.push(response[i]);

                                if (popup.data.accountsList.length > 0)
                                    popup.model.special_account_id = popup.data.accountsList[0].id;

                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    // loyalty_id: itemByIndex($rootScope.TERMINALS, popup.model.terminal_id).loyalty_id,
                                    loyalty_id: $scope.filterHelper.id,
                                    special_account_id: popup.model.special_account_id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.charge_amount,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                if ($scope.data.currentFilter.filter_list_type === 'pos')
                                    post_data.pos_id = $scope.data.currentFilter.id;

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                popup.model.chunk_size = 25;

                                popup.model.users = selectedUsersToArray();
                                popup.model.total_elements = popup.model.users.length;

                                popup.model.request_progress = 0.1;
                                var processRequestOptions = {
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_ADJUSTMENT_SPECIAL_ACCOUNT'), false);
                                    }
                                };
                                if (popup.sendTo == 'all') {
                                    getSavedQuery();
                                    post_data.conditions = $scope.customersFilters.toQuery();
                                    CustomerService.AllIds(post_data, function (success, response) {
                                        popup.model.users = response;
                                        popup.model.total_elements = popup.model.users.length;
                                        processRequest(popup, post_data, TransactionService.AdjustmentSpecialAccounts, $uibModalInstance,
                                            processRequestOptions);
                                    });
                                } else if (popup.sendTo == 'selected') {
                                    processRequest(popup, post_data, TransactionService.AdjustmentSpecialAccounts, $uibModalInstance, processRequestOptions);
                                } else if (popup.sendTo == 'user') {
                                    popup.model.users = [popup.user.user_id];
                                    processRequest(popup, post_data, TransactionService.AdjustmentSpecialAccounts, $uibModalInstance, processRequestOptions);
                                }

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onShowSpecialAccounts = function () {
                            $uibModalInstance.close();
                            $location.path('/client-accounts');
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });

        }

        /**
         * Handling sendmessage button click. Show popup for enter message text
         */
        function popupSendMessage(customer) {
            console.info('popupSendMessage customers', customer);
            console.info('popupSendMessage loy', $scope.data.currentFilter);
            console.info('popupSendMessage Filter', $scope.filterHelper);

            $rootScope.getBusinessStatus();

            $scope.modalSendMessage = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.sendmessage.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};
                    popup.options = {};

                    popup.message_types = [
                        {id: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                        {id: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                        {id: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                        {id: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                        {id: 'push', title: 'TEXT_PUSH'},
                        {id: 'chatbot', title: 'TEXT_CHATBOT'},
                        // {id: 'viber', title: 'TEXT_VIBER'},
                        {id: 'sms', title: 'TEXT_SMS'},
                        {id: 'email', title: 'TEXT_EMAIL'}
                    ];

                    if ($scope.isInCust) {
                        popup.message_types.push({id: 'chatbot', title: 'TEXT_CHATBOT_7LOC'})
                    }

                    popup.isSupportDuplicateByPkpass = false;

                    SettingsService.GetPlatformParams(function (success, response) {
                        if (success) {
                            if (!!response.allow_messages_to_external_system) {
                                popup.message_types.push({
                                    id: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'
                                });
                            }
                            popup.isSupportDuplicateByPkpass = !!response.pkpass_wallet_send_message;
                        }
                    });
                    // popup.type = 'push-chatbot-viber-sms';
                    popup.type = popup.message_types[0].id;
                    popup.model.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    if (customer) {
                        popup.user = customer;
                        popup.sendTo = 'user';
                    } else {
                        popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                    }

                    popup.onOk = function () {
                        var post_data = {
                            loyalty_id: $scope.filterHelper.id,
                            message: popup.message,
                            type: popup.type,
                            duplicate_by_pkpass: !!popup.duplicate_by_pkpass,
                            bonuses_decimal_digits: 2
                        };

                        if ($scope.data.currentFilter.filter_list_type === 'pos')
                            post_data.pos_id = $scope.data.currentFilter.id;

                        popup.model.chunk_size = 25;

                        popup.model.users = selectedUsersToArray();
                        popup.model.total_elements = popup.model.users.length;

                        popup.model.request_progress = 0.01;

                        $scope.sendingResult = {cost: 0, success: 0, error: 0, priceCalculated: false};
                        popup.model.sendingResult = $scope.sendingResult;

                        var request;
                        if (popup.model.step == 1) {
                            request = MessageService.Send;
                            popup.options = {error_report: true};
                            popup.model.chunk_size = 25;
                        } else if (popup.model.step == 0) {
                            request = MessageService.SendPrice;
                            popup.model.chunk_size = 100;
                            popup.options = {price_calc: true};

                            popup.model.step = 1;
                        }

                        if (popup.sendTo == 'all') {
                            getSavedQuery();
                            post_data.conditions = $scope.customersFilters.toQuery();
                            CustomerService.AllIds(post_data, function (success, response) {
                                popup.model.users = response;
                                popup.model.total_elements = popup.model.users.length;
                                processRequest(popup, post_data, request, $uibModalInstance, popup.options);
                            });
                        } else if (popup.sendTo == 'selected') {
                            processRequest(popup, post_data, request, $uibModalInstance, popup.options);
                        } else if (popup.sendTo == 'user') {
                            popup.model.users = [popup.user.user_id];
                            processRequest(popup, post_data, request, $uibModalInstance, popup.options);
                        }

                        $scope.$watch(angular.bind(this, function (model) {
                            return this.model;
                        }), function (newValue, oldValue) {
                            if (newValue) {
                                $timeout(function () {
                                    if (newValue.step === 1 && $scope.sendingResult.priceCalculated) {
                                        $rootScope.getBusinessStatus();
                                        $timeout(function () {
                                            delete popup.model.request_progress;

                                            popup.model.sendingResult = $scope.sendingResult;

                                            if ($scope.sendingResult.cost >
                                                ($rootScope.ENV.business.status.account_balance + $rootScope.ENV.business.status.credit_limit))
                                                popup.model.can_not_be_send = true;
                                        }, 300);
                                    }
                                });
                            }
                        }, true);
                    };

                    popup.onAddMacros = function (m) {
                        if (popup.message)
                            popup.message += ' {{' + m + '}}';
                        else
                            popup.message = '{{' + m + '}}';
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onPaymetnLinkClick = function () {
                        $uibModalInstance.close();
                        $location.path('/payment');
                    };

                    popup.onCancel = function (exit) {
                        popup.model.can_not_be_send = false;

                        if (popup.model.sendingResult)
                            popup.model.sendingResult.error = 0;

                        if (!exit)
                            popup.model.step -= 1;

                        if (exit || popup.model.step < 0)
                            $uibModalInstance.close();
                    };
                }
            });
        }

        /**
         * Handling send notify button click. Show popup for select  text
         */
        function popupSendNotify(customer) {
            console.info('popupAddBonuses', customer);

            $scope.modalSendNotify = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.sendnotify.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.notification_types = [
                        {id: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                        {id: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                        {id: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                        {id: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                        {id: 'push', title: 'TEXT_PUSH'},
                        {id: 'chatbot', title: 'TEXT_CHATBOT'},
                        // {id: 'viber', title: 'TEXT_VIBER'},
                        {id: 'sms', title: 'TEXT_SMS'},
                        {id: 'email', title: 'TEXT_EMAIL'}
                    ];

                    if ($scope.isInCust) {
                        popup.notification_types.push({id: 'chatbot', title: 'TEXT_CHATBOT_7LOC'})
                    }

                    SettingsService.GetPlatformParams(function (success, response) {
                        if (success) {
                            if (!!response.allow_messages_to_external_system) {
                                popup.notification_types.push({
                                    id: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'
                                });
                            }
                        }
                    });
                    popup.model = {};
                    popup.data = {};
                    popup.model.delivery_method = 'push-chatbot-viber-sms';

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    if (customer) {
                        popup.user = customer;
                        popup.sendTo = 'user';
                    } else {
                        popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                    }

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    SelectService.getActualNewsList(function (success, response) {
                        if (success) {
                            popup.data.newsList = response.data;
                            console.log('popup.data.newsList', popup.data.newsList, popup.data.newsList.length);
                            if (response.data.length > 0) {
                                popup.model.news_id = popup.data.newsList[0].id;
                                popup.model.news_title = popup.data.newsList[0].title;
                            }

                        }
                    });

                    popup.onNewsChange = function () {
                        var newsObj = popup.data.newsList && popup.data.newsList.find(function (news) {
                            if (news.id === popup.model.news_id) {
                                return true;
                            }
                        });

                        popup.model.news_title = newsObj.title;
                    };

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                news_id: popup.model.news_id,
                                loyalty_id: $scope.filterHelper.id,
                                bonuses_decimal_digits: 2
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos')
                                post_data.pos_id = $scope.data.currentFilter.id;

                            popup.options = {error_report: true};

                            popup.model.chunk_size = 50;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            $scope.sendingResult = {success: 0, error: 0};

                            if (popup.sendTo === 'all') {
                                getSavedQuery();
                                post_data.conditions = $scope.customersFilters.toQuery();
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, MessageService.SendNotificationNews, $uibModalInstance, popup.options);
                                });
                            } else if (popup.sendTo === 'selected') {
                                processRequest(popup, post_data, MessageService.SendNotificationNews, $uibModalInstance, popup.options);
                            } else if (popup.sendTo === 'user') {
                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, MessageService.SendNotificationNews, $uibModalInstance, popup.options);
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        function popupGiveCouponToCustomers(customer) {
            console.info('popupGiveCoupon', customer);

            $scope.modalGiveCoupon = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.give_coupon.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};
                    popup.data = {};
                    popup.options = {error_log: true, error_report: true};
                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    if (customer) {
                        popup.user = customer;
                        popup.sendTo = 'user';
                    } else {
                        popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';
                    }

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.getBatchesList = function () {
                        var params = {
                            page: 1,
                            count: 500,
                            loyalty: $scope.filterHelper.id
                        };

                        CouponsService.Batches(params, function (success, response) {
                            if (success) {
                                popup.data.batchesList = response.data;

                                if (popup.data.batchesList.length > 0)
                                    popup.data.currentBatch = popup.data.batchesList[0];
                            }
                        });
                    };

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                loyalty_id: $scope.filterHelper.id,
                                batch_id: popup.data.currentBatch.id,
                                skip_message: !!popup.skip_message,
                                comment: popup.comment,
                                emit_new_coupons: true,
                                bonuses_decimal_digits: 2,
                            };

                            if ($scope.data.currentFilter.filter_list_type === 'pos') {
                                post_data.pos_id = $scope.data.currentFilter.id;
                            }

                            popup.model.chunk_size = 50;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            $scope.sendingResult = {success: 0, error: 0, error_log: []};

                            if (popup.sendTo == 'all') {
                                getSavedQuery();
                                post_data.conditions = $scope.customersFilters.toQuery();
                                CustomerService.AllIds(post_data, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, CouponsService.GiveCouponToCustomers, $uibModalInstance, popup.options);
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, CouponsService.GiveCouponToCustomers, $uibModalInstance, popup.options);
                            } else if (popup.sendTo == 'user') {
                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, CouponsService.GiveCouponToCustomers, $uibModalInstance, popup.options);
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.redirectToSeries = function () {
                        $uibModalInstance.close();
                        $location.path('/series');
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        function popupOperationResult(r, o) {
            console.log('popupOperationResult', r, o);
            $scope.modalOperationResult = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.operation_result.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.result = r;
                    popup.options = o;

                    popup.onErrosLogExport = function (format) {
                        var file_name = $rootScope.ENV.business.code + '_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                        switch (format) {
                            case 'XLSX':
                                alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'XLS':
                                alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'CSV':
                                alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [popup.result.error_log]);
                                break;
                        }
                    };

                    popup.onOk = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        function processRequest(popup, post_data, request, modal, options) {
            $scope.model.inlineMessage = '';
            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
            post_data.users = popup.model.chunk;

            if (!post_data.type) {
                post_data.type = popup.model.delivery_method;
            }

            function handleResult(success, data) {
                if (!$rootScope.REQUEST_ABORT_PENDING) {
                    if (success) {
                        popup.model.request_progress += popup.model.chunk.length / popup.model.total_elements * 100;
                        if (options && options.error_report) {
                            $scope.sendingResult.success += data.success;
                            if (data.error) {
                                $scope.sendingResult.error += data.error;
                            }

                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.price_calc) {
                            $scope.sendingResult.cost += data.cost;
                            if (data.error) {
                                $scope.sendingResult.error += data.error;
                            }
                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.error_log) {
                            console.info('options.error_log', $scope.sendingResult);
                            if (data.error && data.error.length > 0) {
                                $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(data.error);
                            } else if (Array.isArray(data) && data.length > 0) {
                                var hasErrors = data.filter(function (item) {
                                    return !!item.error;
                                }).map(function (item) {

                                    if (!item.error_str && !!item.error) {
                                        item.error_str = item.error;
                                    }
                                    return item;
                                });

                                if (hasErrors) {
                                    $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(hasErrors);
                                    $scope.sendingResult.error += hasErrors.length;
                                }
                            }

                        }

                        if (popup.model.users.length > 0) {
                            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
                            post_data.users = popup.model.chunk;
                            request(post_data, handleResult);
                        } else {
                            if (!options || (options && !options.price_calc)) {
                                modal.close();
                            }

                            if (options && options.price_calc) {
                                $scope.sendingResult.priceCalculated = true;
                            }

                            if (options && options.update_user_list) {
                                getCustomers();
                            }

                            if (options && options.refreshCustomerSpecialAccounts) {
                                refreshCustomerSpecialAccounts();
                            }

                            if (options && ($scope.sendingResult && $scope.sendingResult.error_log && $scope.sendingResult.error_log.length > 0 ||
                                options.error_report && !options.price_calc)
                            ) {
                                modal.close();

                                popupOperationResult($scope.sendingResult, options);
                            } else {
                                if (options && options.callbackOnSuccess) {
                                    options.callbackOnSuccess();
                                }
                            }

                        }
                    }
                } else {
                    $rootScope.REQUEST_ABORT_PENDING = false;
                }
            }

            request(post_data, handleResult);
        }

        // *********************************************************************************************
        //  CREATE & EDIT CUSTOMER PART
        // *********************************************************************************************
        $scope.openModalSpecialAccountExtended = function (userId, accountId) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/pages/customers/modals/modal.special-account.extend.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var block_form = blockUI.instances.get('account-extend-form');
                    block_form.start();
                    var popup = this;
                    popup.isCreditLimitUnlimited = false;
                    popup.isDayLimitUnlimited = false;
                    popup.isMonthLimitUnlimited = false;
                    popup.specialAccountGoods = [];
                    popup.availablePosList = [];

                    popup.changeGoodsItem = function (goodCode, event) {
                        if (!popup.account.goods_items) {
                            popup.account.goods_items = [];
                        }
                        if (popup.account.goods_items.indexOf(goodCode) == -1) {
                            popup.account.goods_items.push(goodCode);
                        } else {
                            popup.account.goods_items.splice(popup.account.goods_items.indexOf(goodCode), 1);
                        }
                    };
                    CustomerService.GetCustomerSpecialAccount(userId, accountId, function (success, data) {
                        if (success) {
                            popup.account = angular.copy(data);

                            popup.account.extended = 1;

                            popup.account.odometer = popup.account.odometer ? popup.account.odometer : 'no';
                            popup.isCreditLimitUnlimited = !(data.credit_limit);
                            popup.isDayLimitUnlimited = !(data.day_limit);
                            popup.isMonthLimitUnlimited = !(data.month_limit);

                            if (popup.account.available_until || popup.account.available_from) {
                                popup.account.available_date = 1;

                                if(popup.account.available_until) {
                                    popup.account.available_until = moment(popup.account.available_until).utcOffset(0, true).format();
                                }

                                if(popup.account.available_from) {
                                    popup.account.available_from = moment(popup.account.available_from).utcOffset(0, true).format();
                                }
                            }

                            POSService.All({}, function (success, data) {
                                if (success) {
                                    var posList = angular.copy(data);
                                    popup.availablePosList = posList.filter(function (pos) {
                                        return pos.active;
                                    });
                                    for (var elem in popup.account.pos) {
                                        popup.account.pos[elem] = itemByIndex(popup.availablePosList,
                                            popup.account.pos[elem].id);
                                    }
                                }

                                BusinessService.getSpecialAccountGoods(popup.account.special_account_id, function (success, data) {
                                    if (success) {
                                        popup.specialAccountGoods = angular.copy(data);
                                    }
                                    block_form.stop();
                                });

                            });
                        }

                    });

                    popup.isViewSecurityCode = false;
                    popup.viewSecurityCode = function () {
                        popup.isViewSecurityCode = !popup.isViewSecurityCode;
                    };
                    popup.saveExtendSpecialAccount = function (form) {

                        if (!form.security_code.$valid) {
                            form.security_code.$dirty = true;
                            return;
                        } else {
                            form.security_code.$dirty = false;
                        }

                        block_form.start();

                        var account = angular.copy(popup.account);

                        if (account.security_code == '') {
                            account.security_code = null;
                        }

                        if(account.available_date) {
                            if(account.available_from) {
                                account.available_from = moment(account.available_from).utc().toISOString();
                            }

                            if(account.available_until) {
                                account.available_until = moment(account.available_until).utc().toISOString();
                            }
                        } else {
                            account.available_from = null;
                            account.available_until = null;
                        }

                        delete account.available_date;

                        if (!!account.extended) {
                            CustomerService.UpdateSpecialAccountCustomer(userId, accountId, account, function (success, data) {
                                if (success) {
                                    refreshCustomerSpecialAccounts(function () {
                                        $uibModalInstance.close();
                                    });
                                }
                                //  block_form.stop();
                            });
                        } else {
                            CustomerService.UpdateSpecialAccountCustomer(userId, accountId, {extended: 0}, function (success, data) {
                                if (success) {
                                    refreshCustomerSpecialAccounts(function () {
                                        $uibModalInstance.close();
                                    });
                                }

                            });
                        }
                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.addAccessSpecialAccount = function (accountId) {
            CustomerService.AddSpecialAccountCustomer($routeParams.customer_id, {special_account_id: accountId}, function (success, data) {
                if (success) {
                    refreshCustomerSpecialAccounts();
                }
            });
        };

        function refreshCustomerSpecialAccounts(callback) {
            if (!$routeParams.customer_id) {
                if (callback) {
                    callback();
                }

                // block_edit_corporate_user.stop();
                return;
            }
            block_customer_special_account_table.start();
            BusinessService.SpecialAccounts(function (success, SpecialAccountsData) {
                if (success) {
                    CustomerService.GetCustomerSpecialAccounts($routeParams.customer_id, function (success, data) {
                        if (success) {
                            var availableCustomerSpecialAccounts = angular.copy(data);
                            $scope.customerSpecialAccounts = angular.copy(SpecialAccountsData).map(function (account) {
                                var isAvailable = availableCustomerSpecialAccounts.find(function (availableAccount) {
                                    return availableAccount.special_account_id === account.id;
                                });
                                if (isAvailable) {
                                    account.available = isAvailable;
                                }

                                return account;
                            });
                        }

                        if (callback) {
                            callback();
                        }
                        block_customer_special_account_table.stop();
                    });

                } else {
                    if (callback) {
                        callback();
                        block_customer_special_account_table.stop();
                    }
                }
            });
            // CustomerService.GetCustomerSpecialAccounts($routeParams.customer_id, function(success, data) {
            //   if (success) {
            //     $scope.customerSpecialAccounts = data;
            //   }
            //   if (callback) {
            //     callback();
            //   }
            // });
        }

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            //$scope.onChangeTab('edit-customer');
            $scope.model = {
                access_type: 'full-bonuses-access',
                consent_exist: false,
                consent: ''
            };

            $scope.customerFields = $rootScope.CUSTOMER_FIELDS;

            for (var i in $scope.customerFields)
                $scope.customerFields[i].value = null;

            updateCardCategoriesControl();
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {
            block_edit_client.start();

            CustomerService.BusinessCustomer($routeParams.customer_id, $routeParams.loyalty_id, function (success, response) {
                if (success) {

                    $scope.customerFields = $rootScope.CUSTOMER_FIELDS;

                    for (var i in response) {
                        if ($scope.customerFields && i.indexOf('bcf_') !== -1) {
                            var clean_id = i.substring(i.indexOf('_') + 1, i.lastIndexOf('_'));
                            switch (itemByIndex($scope.customerFields, clean_id).type) {
                                case 'integer':
                                    itemByIndex($scope.customerFields, clean_id).value = parseInt(response[i]);
                                    break;
                                case 'date':
                                    if (response[i]) {
                                        itemByIndex($scope.customerFields, clean_id).value = moment(response[i]).startOf('day').format('YYYY-MM-DD');
                                    } else {
                                        itemByIndex($scope.customerFields, clean_id).value = undefined;
                                    }
                                    break;
                                default:
                                    itemByIndex($scope.customerFields, clean_id).value = response[i];
                            }
                        }
                    }

                    // $scope.model = angular.copy(response);

                    $scope.model = {
                        loyalty_id: $routeParams.loyalty_id,
                        user_id: response.user_id,
                        external_id: response.user_external_id,
                        phone: response.user_phone,
                        email: response.user_email,
                        consent_exist: response.consent_exist,
                        consent: '',
                        access_type: response.access_type,
                        card_category_id: response.card_category_id,
                        user_name: response.user_name,
                        user_name_change_allowed: response.user_name_change_allowed,
                        user_gender_change_allowed: response.user_gender_change_allowed,
                        user_birth_date_change_allowed: response.user_birth_date_change_allowed,
                        user_gender: response.user_gender,
                        user_birth_date: response.user_birth_date ? moment(response.user_birth_date).toDate() : null,
                        customer_additional_cards: response.customer_additional_cards
                    };

                    updateCardCategoriesControl($scope.model.loyalty_id);
                    if ($routeParams && $routeParams['tab']) {
                        $scope.onChangeTab($routeParams['tab']);
                    }
                }
                block_edit_client.stop();
            });
        }

        /**
         * Start edit customer
         */
        // function onEditCustomer (id, loyalty_id) {
        //     $location.path('/customers/edit/{0}/{1}'.format(id, loyalty_id));
        // }

        // $scope.onCardListComplete = function (items) {
        //     // $scope.model.loyalty_id = $scope.filterHelper.id;
        //     if (!$scope.model.category_id) {
        //         $scope.card_category = items[0];
        //         $scope.model.category_id = $scope.card_category.id;
        //     }
        // };

        /**
         * Add empty language
         */
        $scope.onSaveCustomer = function (form, redirectToEdit) {
            function receiveResult(success, data) {
                if (success) {
                    $scope.model.inlineMessage = '';

                    if(!redirectToEdit) {
                        if ($routeParams['r']) {
                            $location.path('/' + $routeParams['r']);
                            $location.search('r', null);
                        } else {
                            $location.path('/customers');
                        }
                    } else {
                        $location.path(('/customers/edit/{0}/{1}').format(data.user_id, data.loyalty_id));
                    }

                } else {
                    if (data.description)
                        $scope.model.inlineMessage = data.description;
                    else
                        $scope.model.inlineMessage = data.message;
                }
                block_edit_client.stop();
            }

            var post_data = angular.copy($scope.model);

            if ($scope.isPageMode('create')) {
                post_data.loyalty_id = $scope.filterHelper.id;
            } else {
                post_data.loyalty_id = $routeParams.loyalty_id;
            }

            for (var i in $scope.customerFields) {
                var fieldName = 'bcf_{0}_value'.format($scope.customerFields[i].id.replace(/[-]*/g, ''));
                if ($scope.customerFields[i].type === 'date') {
                    post_data[fieldName] = $scope.customerFields[i].value
                        ? moment($scope.customerFields[i].value).format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                        : null;
                } else {
                    post_data[fieldName] = $scope.customerFields[i].value;
                }
            }

            if (post_data.user_birth_date)
                post_data.user_birth_date = moment(post_data.user_birth_date).format('YYYY-MM-DD');

            block_edit_client.start();
            post_data = cleanRequestData(post_data);

            if ($scope.isPageMode('create')) {
                CustomerService.BusinessCustomerNew(post_data, receiveResult);
            } else {
                console.info('EDIT');
                CustomerService.BusinessCustomerEdit(post_data, receiveResult);
            }
        };

        // $scope.cardsTagsHandler = function (card){
        //     return card;
        // }

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            if ($routeParams['r']) {
                $location.path('/' + $routeParams['r']);
                $location.search('r', null);
            } else {
                $location.path('/customers');
            }
        };

        // $scope.onCleanInlineMessage = function () {
        //     $scope.model.inlineMessage = '';
        // }

        $scope.onDisplaySettingsClick = function () {
            if ($scope.state.showTableDisplaySettings)
                $rootScope.paramsQueryStore(storage_table_cols, $scope.table_cols);

            $scope.state.showTableDisplaySettings = !$scope.state.showTableDisplaySettings;
        };

        $scope.onDisplaySettingsSave = function () {
            // $rootScope.paramsQueryStore(storage_table_cols, $scope.table_cols);
            // NotifyService.Success("", false);
            $scope.onDisplaySettingsClick();
        };

        // *************************************************************************************************************
        //  EDIT FIELDS PART
        // *************************************************************************************************************

        function doEditFields() {
            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.change_customer_questionnaire) {
                        $scope.newField = {
                            type: 'string',
                            dictionary: []
                        };
                        $rootScope.TARIFF_LIMITATION.change_customer_questionnaire = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.change_customer_questionnaire = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        /**
         * Add new field
         */
        $scope.onAddFieldClick = function () {
            var post_data = angular.copy($scope.newField);
            post_data.dictionary_values = $scope.newField.dictionary;

            CustomerService.CustomerFieldAdd(post_data, function (success, data) {
                if (success) {
                    $scope.customerFields = $rootScope.CUSTOMER_FIELDS;
                    doEditFields();
                }
            });
        };

        /**
         * Save existing field
         */
        $scope.onFieldSave = function (field) {

            CustomerService.CustomerFieldChange(field.id, field, function (success, data) {
                if (success) {
                    $scope.customerFields = $rootScope.CUSTOMER_FIELDS;
                }
            });
        };

        $scope.preEditField = function (field) {
            field._temp_dictionary_values = field.dictionary_values;
        };

        $scope.onFieldCancel = function (field) {
            if (!!field._temp_dictionary_values) {
                field.dictionary_values = field._temp_dictionary_values;
            }
        };
        /**
         * Delete existing field
         */
        $scope.onDeleteFieldClick = function (f) {
            CustomerService.CustomerFieldDelete(f.id, function (success, data) {
                if (success) {
                    $scope.customerFields = $rootScope.CUSTOMER_FIELDS;
                }
            });
        };

        /**
         * Saving custome fields order
         */
        $scope.onSaveFieldOrderClick = function () {
            var fieldsSaved = false;
            var post_data = [];
            for (var i in $scope.customerFields) {
                post_data.push($scope.customerFields[i].id);
                $scope.customerFields[i].sort_order = parseInt(i);
            }
            console.info('SORT ARRAY', post_data);
            CustomerService.CustomerFieldsSaveOrders(post_data, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                }
            });
        };

        // $scope.dictToString = function (dict) {
        //     return dict.join(', ');
        // };

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push(values_list[i]);
                    }
                }
            }
        };

        /**
         * Return style for column header
         * @param col_name: Column (field) name
         * @returns {{sorting_asc: boolean, sorting_desc: boolean}}
         */
        $scope.getTableHeaderClass = function (col_name) {
            return {
                'sorting_asc': $scope.params.sort_field == col_name && $scope.params.sort_direction == 'ASC',
                'sorting_desc': $scope.params.sort_field == col_name && $scope.params.sort_direction == 'DESC'
            };
        };

        /**
         * handling sort order
         */
        $scope.onSortOrderChange = function (field) {
            console.info('SORT', field);
            $scope.model.selectedAll = false;
            $scope.selectedUsers = {};
            if ($scope.params.sort_field == field)
                $scope.params.sort_direction = $scope.params.sort_direction == 'ASC' ? 'DESC' : 'ASC';
            else
                $scope.params.sort_direction = 'ASC';

            $scope.params.sort_field = field;
            getCustomers();
        };

        /**
         * Received when user chane page
         */
        $scope.pageChange = function () {
            getCustomers();
        };

        /**
         * handling items on page count
         */
        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getCustomers();
        };

        // $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
        //     if (newValue && newValue.length>0) {
        //         $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

        //         if ($rootScope.ENV.filters && $rootScope.ENV.filters.customers_list && $rootScope.ENV.filters.customers_list.loyalty_id)
        //             $scope.filterHelper.id = $rootScope.ENV.filters.customers_list.loyalty_id;

        //         if (!$scope.filterHelper.id)
        //            $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
        //     }
        // });

        // $scope.$watch('filterHelper.id', function(newValue, oldValue, scope) {
        //     if (newValue && newValue !== oldValue) {
        //         if ($scope._pageMode === 'show') {
        //             doShow();

        //             $scope.selectedUsers = {};
        //             $scope.customersFilters.removeCardCategoryCondition();

        //             $rootScope.ENV.filters.customers_list = {
        //                 loyalty_id: newValue,
        //             }
        //             $rootScope.storeENV();
        //         }
        //     }
        // });

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
                if (newValue && newValue.length > 0) {
                    $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                    $scope.data.filtersList = [];
                    for (var i in $rootScope.LPR_LIST)
                        if ($rootScope.LPR_LIST[i].filter_list_type === 'loyalty' || $rootScope.LPR_LIST[i].filter_list_type === 'pos')
                            $scope.data.filtersList.push($rootScope.LPR_LIST[i]);

                    // if ($scope._pageMode === 'show')
                    //     $scope.data.filtersList.unshift({title: $filter('translate')('All loyalties'), id: '0', active: 1});

                    var saved_filter;

                    // choose current filter
                    if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                        $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {
                            if (filterItem.filter_list_type === 'loyalty') {
                                if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                    return true;
                                }
                            } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                                if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                    return true;
                                }
                            }
                        });
                    }

                    if (!$scope.data.currentFilter)
                        $scope.data.currentFilter = getFirstActive($scope.data.filtersList);

                    var cf = $scope.data.currentFilter;

                    if (cf.filter_list_type === 'loyalty')
                        $scope.filterHelper.id = cf.id;
                    else if (cf.filter_list_type === 'pos')
                        $scope.filterHelper.id = cf.loyalty_id;

                    if (!$scope.filterHelper.id)
                        $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
                }
            }
        );

        $scope.onSelectFilter = function () {
            doShow();
        };

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {

            console.log('watch data.currentFilter', newValue);
            if (newValue && newValue !== oldValue && $scope._pageMode === 'show') {
                $scope.filterHelper.id = newValue.filter_list_type == 'pos' ? newValue.loyalty_id : newValue.id;
                $scope.selectedUsers = {};
                $scope.customersFilters.removeCardCategoryCondition();

                $rootScope.ENV.filters.customers_list = {
                    filter: newValue
                };

                if (newValue.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                } else if (newValue.filter_list_type === 'pos' || newValue.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.loyalty_id};
                } else if (newValue.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                }
                $rootScope.storeENV();
            }
        }, true);

        // =============================================================================================================
        // CustomersFilters OBJECT
        // =============================================================================================================
        function CustomersFilters() {
            var cf = {
                fields: [],
                dictLists: {},
                store: {default: [[]]},
                currentSetName: 'default'
            };

            // Property currentSet
            Object.defineProperty(cf, 'currentSet', {
                enumerable: true,
                configurable: true,
                get: function () {
                    return cf.store[cf.currentSetName];
                },
                set: function (set) {
                    cf.store[cf.currentSetName] = angular.copy(set);
                }
            });

            var staticFields = [
                {id: '-', description: 'Main user fields'},
                {
                    id: 'user_status',
                    type: 'dictionary',
                    description: 'Customer status',
                    dictionary_values: {
                        active: $filter('translate')('TEXT_CUSTOMER_STATUS_ACTIVE'),
                        registered: $filter('translate')('TEXT_CUSTOMER_STATUS_REGISTERED'),
                        banned: $filter('translate')('TEXT_CUSTOMER_STATUS_BANNED'),
                        suspended: $filter('translate')('TEXT_CUSTOMER_STATUS_SUSPENDED')
                    }
                },
                {id: 'user_phone', type: 'string', description: 'Customer phone'},
                {id: 'user_external_id', type: 'string', description: 'Customer external id'},
                {id: 'user_email', type: 'string', description: 'Customer email'},
                {id: 'user_name', type: 'string', description: 'Customer name'},
                {
                    id: 'user_gender',
                    type: 'dictionary',
                    description: 'Customer gender',
                    dictionary_values: {
                        male: 'Male',
                        female: 'Female',
                        other: 'Other'
                    }
                },
                {id: 'user_birth_date', type: 'date', description: 'Customer birth date'},
                {id: 'user_country', type: 'string', description: 'Country'},
                {id: 'user_language', type: 'dictionary', description: 'Language', dictionary_values: LANGS},
                {id: 'user_mobile_client_in_use', type: 'bool', description: 'Using mobile app'},
                {
                    id: 'access_type',
                    type: 'dictionary',
                    description: 'Access to bonuses account',
                    dictionary_values: {
                        'full-bonuses-access': 'full-bonuses-access',
                        'add-bonuses-only': 'add-bonuses-only',
                        'waiting-for-confirmation': 'waiting-for-confirmation',
                        'in-black-list': 'in-black-list'
                    }
                },
                {id: '-', description: 'Cards'},
                {
                    id: 'card_category_id',
                    type: 'dictionary',
                    description: 'Card category type',
                    dynamic: true,
                    request: LoyaltyService.CardCategories
                },

                {id: 'customer_additional_cards', type: 'string', description: 'Customer additional cards'},

                {id: '-', description: 'Sales'},
                {id: 'sale_count', type: 'integer', description: 'Sale count'},
                {id: 'average_cheque', type: 'number', description: 'Average cheque'},
                {id: 'bonuses_added', type: 'number', description: 'Bonuses added'},
                {id: 'bonuses_redeemed', type: 'number', description: 'Bonuses redeemed'},
                {id: 'bonuses_on_hand', type: 'number', description: 'Bonuses on hand'},
                {id: 'transactions_amount', type: 'number', description: 'Transactions amount'},
                {id: 'transactions_discount_amount', type: 'number', description: 'Discount amount'},
                {id: 'first_transaction_date', type: 'date', description: 'first_transaction_date'},
                {id: 'first_transaction_days_from', type: 'integer', description: 'first_transaction_days_from'},
                {id: 'first_sale_transaction_date', type: 'date', description: 'first_sale_transaction_date'},
                {
                    id: 'first_sale_transaction_days_from',
                    type: 'integer',
                    description: 'first_sale_transaction_days_from'
                },
                {id: 'last_transaction_date', type: 'date', description: 'last_transaction_date'},
                {id: 'last_transaction_days_from', type: 'integer', description: 'last_transaction_days_from'},
                {id: 'last_sale_transaction_date', type: 'date', description: 'last_sale_transaction_date'},
                {
                    id: 'last_sale_transaction_days_from',
                    type: 'integer',
                    description: 'last_sale_transaction_days_from'
                }
            ];

            cf.conditionLists = [
                {id: 'IS NOT', text: 'Exist'},
                {id: 'IS', text: 'Not exist'},
                {id: '=', text: 'Equals', type: 'bool,string,integer,number,date'},
                {id: '<>', text: 'Not equals', type: 'string'},
                {id: 'LIKE', text: 'Contain', type: 'string'},
                {id: 'LIKE_', text: 'Start from', type: 'string'},
                {id: '>', text: 'Greater than', type: 'integer,number,date'},
                {id: '<', text: 'Less than', type: 'integer,number,date'},
                {id: '=', text: 'Equals', type: 'dictionary'},
                {id: '<>', text: 'Not equals', type: 'dictionary'}
            ];

            cf.fields = angular.copy(staticFields);

            cf.fieldValuesList = {};

            cf.staticFieldsIds = [];
            for (var i in staticFields)
                cf.staticFieldsIds.push(staticFields[i].id);

            cf.addCustomerFields = function (fields) {
                cf.fields = [{id: '-', description: 'Custom fields'}];
                if (fields && fields.length > 0) {
                    cf.fields = cf.fields.concat(fields);
                } else {
                    cf.fields.push({id: '--', description: '[fields not set]'});
                }
                cf.fields = cf.fields.concat(staticFields);
            };

            cf.getUIList = function (options, callback) {
                var list_data = [];
                cf.fields.forEach(function (item) {
                    list_data.push({
                        id: item.id,
                        text: item.id == '-' ? '<strong>{0}</strong>'.format(item.description) : '&nbsp;' + item.description,
                        disabled: item.id == '-',
                        object: item
                    });
                });
                callback(list_data);
            };

            cf.getUITreeList = function (options, callback, user_external_id) {
                var tree_data = [];
                if (!user_external_id) {
                    var index_user_status = cf.fields.findIndex(function (f) {
                        return f.id === 'user_external_id';
                    });
                    if (index_user_status !== -1) {
                        cf.fields.splice(index_user_status, 1);
                    }
                }

                cf.fields.forEach(function (item) {
                    if (item.id == '-') {
                        tree_data.push({
                            id: item.id,
                            text: item.description,
                            has_children: true,
                            children: [],
                            object: item
                        });
                    } else {
                        tree_data[tree_data.length - 1].children.push({
                            id: item.id,
                            text: item.description,
                            has_children: false,
                            object: item
                        });
                    }
                });
                callback(tree_data);
            };

            cf.isAppliable = function (list, item) {
                var r = [];
                for (var i in list) {
                    if (!list[i].type)
                        r.push(list[i]);

                    if (list[i].type && item.type && list[i].type.indexOf(item.type) !== -1)
                        r.push(list[i]);
                }

                return r;
            };

            cf.makeDictList = function (f) {
                var l = [],
                    field = itemByIndex(cf.fields, f.field);

                if (field) {
                    switch (field.type) {
                        case 'bool':
                            l = [
                                {id: 1, title: 'Yes'},
                                {id: 0, title: 'No'}
                            ];

                            cf.fieldValuesList[f.field] = l;

                            if (!f.value)
                                f.value = l[0].id;
                            break;
                        case 'dictionary':
                            if (field.dynamic) {
                                field.request($scope.filterHelper.id, function (success, response) {
                                    if (success) {
                                        l = response;
                                        cf.fieldValuesList[f.field] = l;

                                        if (l.length > 0)
                                            f.value = l[0].id;
                                    }
                                });
                            } else {
                                if (Object.prototype.toString.call(field.dictionary_values) === '[object Array]') {
                                    for (var i in field.dictionary_values) {
                                        if (!f.value)
                                            f.value = field.dictionary_values[i].id;

                                        l.push({id: field.dictionary_values[i], title: field.dictionary_values[i]});
                                    }

                                    cf.fieldValuesList[f.field] = l;
                                } else {
                                    for (var i in field.dictionary_values)
                                        l.push({id: i, title: field.dictionary_values[i]});

                                    cf.fieldValuesList[f.field] = l;

                                    if (!f.value)
                                        f.value = l[0].id;
                                }

                            }
                            break;
                    }
                }
            };

            /**
             * Make string with filters fot URL query
             */
            cf.toQuery = function (forURL) {
                if (cf.currentSet[0].length == 0)
                    return null;

                var result = [];

                cf.currentSet.forEach(function (group) {
                    var new_group = [];
                    group.forEach(function (item) {
                        var new_item = {
                            field: customFieldSQLName(item.field),
                            condition: item.condition
                        };

                        if (item.condition.indexOf('IS') == 0) {
                            new_item.value = 'NULL';
                        } else if (item.type == 'date' && item.field != 'user_birth_date') {
                            new_item.value = moment(item.value).format('\'YYYY-MM-DD\'');
                        } else if (item.type == 'date' && item.field == 'user_birth_date') {
                            var new_item_year = angular.copy(new_item);
                            var new_item_month = angular.copy(new_item);
                            var new_item_day = angular.copy(new_item);

                            if (item.value && item.value.year) {
                                new_item_year.field = 'user_birth_date_year';
                                new_item_year.value = item.value.year;
                                new_group.push(new_item_year);
                            }
                            if (item.value && item.value.month) {
                                new_item_month.field = 'user_birth_date_month';
                                new_item_month.value = item.value.month;
                                new_group.push(new_item_month);
                            }
                            if (item.value && item.value.day) {
                                new_item_day.field = 'user_birth_date_day';
                                new_item_day.value = item.value.day;
                                new_group.push(new_item_day);
                            }
                        } else if (item.type == 'string') {
                            switch (item.condition) {
                                case 'LIKE':
                                    new_item.value = '\'%{0}%\''.format(item.value);
                                    break;
                                case 'LIKE_':
                                    new_item.condition = 'LIKE';
                                    new_item.value = '\'{0}%\''.format(item.value);
                                    break;
                                default:
                                    new_item.value = '\'{0}\''.format(item.value);
                                    break;
                            }
                        } else if (item.type == 'dictionary') {
                            new_item.value = '\'{0}\''.format(item.value);
                        } else {
                            new_item.value = item.value;
                        }

                        if (item.field !== 'user_birth_date' || (item.field === 'user_birth_date' && item.condition.indexOf('IS') === 0))
                            new_group.push(new_item);

                    });
                    result.push(new_group);
                });

                console.info('QUERY', result);

                var s_result;

                if (result && result.length === 1 && result[0].length === 0)
                    s_result = null;
                else
                    s_result = angular.toJson(result);

                if (forURL)
                    s_result = encodeURIComponent(s_result);

                return s_result;
            };

            cf.setCurrentSet = function (set) {
                cf.currentSet = set;
            };

            cf.getCurrentSet = function () {
                return cf.currentSet;
            };

            cf.toObject = function (query) {
                var q = JSON.parse(query);

                for (var i in q) {
                    cf.currentSet[i] = [];
                    for (var k in q[i]) {
                        if (q[i][k].field.indexOf('user_birth_date') === -1) {
                            cf.currentSet[i][k] = angular.copy(q[i][k]);
                            cf.currentSet[i][k].type = cf.fieldInStaticFields(q[i][k]).type;

                            if (cf.currentSet[i][k].type == 'string') {
                                switch (cf.currentSet[i][k].condition) {
                                    case 'LIKE':
                                        cf.currentSet[i][k].value = cf.currentSet[i][k].value.replace(/\'/g, '').replace(/\%/g, '');
                                        break;
                                    case 'LIKE_':
                                        cf.currentSet[i][k].value = cf.currentSet[i][k].value.replace(/\'/g, '').replace(/\%/g, '');
                                        break;
                                    default:
                                        cf.currentSet[i][k].value = cf.currentSet[i][k].value.replace(/\'/g, '');
                                        break;
                                }
                            }

                            if (cf.currentSet[i][k].type === 'date')
                                cf.currentSet[i][k].value = moment(cf.currentSet[i][k].value, 'YYYY-MM-DD').toDate();

                            if (cf.currentSet[i][k].type === 'dictionary')
                                cf.currentSet[i][k].value = cf.currentSet[i][k].value.replace(/\(/g, '').replace(/\)/g, '').replace(/\'/g, '');
                        } else {
                            var index;
                            for (var l in cf.currentSet[i]) {
                                if (cf.currentSet[i][l].field.indexOf('user_birth_date') != -1) {
                                    index = l;
                                    break;
                                }
                            }

                            if (index) {
                                if (q[i][k].field === 'user_birth_date_year')
                                    cf.currentSet[i][index].value.year = q[i][k].value;
                                if (q[i][k].field === 'user_birth_date_month')
                                    cf.currentSet[i][index].value.month = q[i][k].value;
                                if (q[i][k].field === 'user_birth_date_day')
                                    cf.currentSet[i][index].value.day = q[i][k].value;
                            } else {
                                cf.currentSet[i][k] = angular.copy(q[i][k]);

                                cf.currentSet[i][k].value = {};
                                if (q[i][k].field === 'user_birth_date_year')
                                    cf.currentSet[i][k].value.year = q[i][k].value;
                                if (q[i][k].field === 'user_birth_date_month')
                                    cf.currentSet[i][k].value.month = q[i][k].value;
                                if (q[i][k].field === 'user_birth_date_day')
                                    cf.currentSet[i][k].value.day = q[i][k].value;

                                cf.currentSet[i][k].type = 'date';
                                cf.currentSet[i][k].field = 'user_birth_date';
                            }
                        }
                    }
                }
            };

            cf.fieldInStaticFields = function (item) {
                for (var i in cf.fields) {
                    var id = '';
                    if (item.field.indexOf('bcf_') !== -1)
                        id = item.field.substring(item.field.indexOf('_') + 1, item.field.lastIndexOf('_'));
                    else
                        id = item.field;

                    if (cf.fields[i].id.replace(/-/g, '') === id)
                        return cf.fields[i];
                }
            };

            /**
             * Delete all Card Category Type condition.
             * Need when change loyalty
             */
            cf.removeCardCategoryCondition = function () {
                cf.currentSet.forEach(function (group) {
                    console.info('removeCardCategoryCondition group', group);
                    for (var item in group) {
                        console.info('removeCardCategoryCondition item', group[item]);
                        if (group[item].field == 'card_category_id') {
                            group.splice(item, 1);
                        }
                    }

                    // Delete group from filter if empty
                    if (group.length == 0 && cf.currentSet.length > 1) {
                        cf.currentSet.splice(cf.currentSet.indexOf(group), 1);
                    }
                });
            };

            // *********************************************************************************************
            //  UI PART
            // *********************************************************************************************

            /**
             * Return field description (title)
             * @param id: Field name
             */
            cf.getTitle = function (id) {
                if (id.indexOf('user_birth_date') != -1)
                    id = 'user_birth_date';

                if (id.indexOf('bcf_') !== -1)
                    id = id.split('_')[1];

                var field = itemByIndex(cf.fields, id);
                return field ? field.description : id;
            };

            /**
             * Return true if control need show
             * @param condition: Condition object
             * @param control: Control type
             */
            cf.needControl = function (condition, control) {
                if (condition.field.indexOf('user_birth_date') != -1)
                    condition.field = 'user_birth_date';

                if (condition.field.indexOf('bcf_') !== -1)
                    condition.field = condition.field.split('_')[1];

                var field = itemByIndex(cf.fields, condition.field);

                return control && field && field.type && (condition.condition.indexOf('IS') == -1) && (
                    (control == 'text' && 'string,integer,number'.indexOf(field.type) > -1) ||
                    (control == 'date' && field.type == 'date') ||
                    (control == 'select' && 'bool,dictionary'.indexOf(field.type) > -1)
                );
            };

            /**
             * Add AND condition to specified tree (group)
             * @param group: Specified group
             * @param id: Field id
             */
            cf.addAND = function (group, id) {
                console.info('AND', id);
                var field = itemByIndex(cf.fields, id);

                group.push({
                    field: id,
                    type: field.type,
                    condition: 'IS NOT'
                });

            };

            /**
             * Add new condition tree OR
             * @param id: Field id for first condition
             */
            cf.addOR = function (id) {
                console.info('OR');
                var group = [];
                cf.currentSet.push(group);
                cf.addAND(group, id);
            };

            /**
             * Delete condition AND from own group
             * @param group: Owner group object
             * @param item: Removed condition item
             */
            cf.deleteAND = function (group, item) {
                group.splice(group.indexOf(item), 1);
                console.info('DELETE', group);

                // Delete group from filter if empty
                if (group.length === 0 && cf.currentSet.length > 1)
                    cf.currentSet.splice(cf.currentSet.indexOf(group), 1);

                // if (cf.currentSet.length === 1) {
                //     $scope.params.conditions = null;
                //     $rootScope.paramsQueryClean(storage_query);
                // }
            };

            /**
             * Reset (clear) filters
             */
            cf.resetFilters = function () {
                $scope.selectedUsers = {};
                $scope.params.conditions = null;

                cf.store.default = [[]];
                cf.currentSetName = 'default';

                $rootScope.paramsQueryClean(storage_query);
                getCustomers();
            };

            /**
             * Apply users filters
             */
            cf.applyFilters = function () {
                $scope.selectedUsers = {};
                $scope.params.page = 1;

                $scope.params.conditions = null;
                $rootScope.paramsQueryClean(storage_query);
                getCustomers();
            };

            return cf;
        }

        $scope.onCustomersExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_clients_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;
            block_clients_list.start();

            var cf = $scope.data.currentFilter,
                params = {
                    page: $scope.params.page,
                    count: $scope.params.count,
                    conditions: $scope.params.conditions ? $scope.params.conditions : $scope.customersFilters.toQuery()
                };

            if (cf.filter_list_type === 'loyalty') {
                params.loyalty_id = cf.id;
            } else if (cf.filter_list_type === 'pos') {
                params.loyalty_id = cf.loyalty_id;
                params.pos_id = cf.id;
            }
            if ($scope.params.sort_field && $scope.params.sort_direction)
                params.sort = '{0} {1}'.format(customFieldSQLName($scope.params.sort_field), $scope.params.sort_direction);

            if (!params.conditions) {
                delete params.conditions;
                $scope.data.showAdvancedFilters = false;
            }

            params.slow_request = true;

            $rootScope.paramsQueryStore(storage_customers_filters_set, $scope.customersFilters.getCurrentSet());

            var tl = [];
            var hasSpacialAccounts = false;

            if ($scope.businessSpecialAccounts && $scope.businessSpecialAccounts.length > 0) {
                for (var i in $scope.table_cols) {
                    if ($scope.table_cols[i].visible) {
                        for (var k in $scope.table_cols[i].data) {
                            if ($scope.table_cols[i].data[k].value === 'special_accounts' && $scope.table_cols[i].data[k].visible) {
                                hasSpacialAccounts = true;
                            }
                        }
                    }
                }
            }

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_customers';

                var export_struct = [];
                for (var i in $scope.table_cols) {
                    if ($scope.table_cols[i].visible) {
                        for (var k in $scope.table_cols[i].data) {
                            if ($scope.table_cols[i].data[k].value !== 'special_accounts') {
                                if ($scope.table_cols[i].data[k].visible) {
                                    export_struct.push({
                                        text: $filter('translate')($scope.table_cols_preset[i].data[k].text),
                                        value: $scope.table_cols_preset[i].data[k].value
                                    });
                                }
                            } else {
                                if ($scope.businessSpecialAccounts && $scope.businessSpecialAccounts.length > 0) {


                                    $scope.businessSpecialAccounts.forEach(function (el, i) {
                                        export_struct.push(
                                            {
                                                text: $filter('translate')('Public title') + ' (' + el.title + ')',
                                                value: 'special_title',
                                                id: el.id
                                            },
                                            {
                                                text: $filter('translate')('Account type') + ' (' + el.title + ')',
                                                value: 'special_type',
                                                id: el.id
                                            },
                                            {
                                                text: $filter('translate')('Remaining special account') + ' (' + el.title + ')',
                                                value: 'special_balance',
                                                id: el.id
                                            },
                                            {
                                                text: $filter('translate')('Currency price group') + ' (' + el.title + ')',
                                                value: 'special_currency',
                                                id: el.id,
                                                currency: el.currency
                                            },
                                            {
                                                text: $filter('translate')('Status extended') + ' (' + el.title + ')',
                                                value: 'special_extended',
                                                id: el.id
                                            }
                                        );
                                    })
                                }
                            }
                        }
                    }
                }

                for (var i in $rootScope.CUSTOMER_FIELDS) {
                    if ($rootScope.CUSTOMER_FIELDS[i]) {
                        var field_number = 1 + +i;
                        var customer_field = {
                            text: $rootScope.CUSTOMER_FIELDS[i].description + `[${field_number}]`,
                            value: $rootScope.CUSTOMER_FIELDS[i].value_field_name,
                        }
                        export_struct.push(customer_field)
                    }

                }

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        try {
                            var a, b;
                            a = export_struct[k].text;


                            switch (export_struct[k].value) {
                                case 'user_mobile_client_in_use':
                                    if (tl[i][export_struct[k].value] == 1) {
                                        b = $filter('translate')('Yes');
                                    } else {
                                        b = $filter('translate')('No');
                                    }
                                    break;
                                case 'customer_additional_cards':
                                    b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                                    break;
                                case 'sale_count':
                                    b = (tl[i][export_struct[k].value] === null) ? Math.round(parseFloat('0')) : Math.round(
                                        parseFloat(tl[i][export_struct[k].value]));
                                    break;
                                case 'transactions_amount':
                                case 'average_cheque':
                                case 'bonuses_added':
                                case 'bonuses_redeemed':
                                case 'bonuses_on_hand':
                                case 'transactions_discount_amount':
                                    b = (tl[i][export_struct[k].value] === null) ? parseFloat('0').toFixed(2) : parseFloat(tl[i][export_struct[k].value]).toFixed(2);
                                    break;
                                case 'first_transaction_dt':
                                case 'last_transaction_dt':
                                case 'first_sale_transaction_dt':
                                case 'last_sale_transaction_dt':
                                    b = (tl[i][export_struct[k].value] === null) ? '' : moment(tl[i][export_struct[k].value]).format('YYYY-MM-DD HH:mm:ss');
                                    break;
                                case 'first_transaction_days_from':
                                case 'first_sale_transaction_days_from':
                                case 'last_transaction_days_from':
                                case 'last_sale_transaction_days_from':
                                    b = (tl[i][export_struct[k].value] === null) ? '' : Math.round(parseFloat(tl[i][export_struct[k].value]));
                                    break;

                                case 'special_title':
                                    if (tl[i].specials && tl[i].specials.length > 0) {
                                        var spec = tl[i].specials.find(function (el) {
                                            return el.special_account_id === export_struct[k].id
                                        });
                                        b = spec && spec.special_account_title ? spec.special_account_title : '';
                                    } else {
                                        b = '';
                                    }
                                    break;
                                case 'special_type':
                                    if (tl[i].specials && tl[i].specials.length > 0) {
                                        var special = tl[i].specials.find(function (el) {
                                            return el.special_account_id === export_struct[k].id
                                        });

                                        if (special && special.special_account_type) {
                                            var name = ''
                                            if (special.special_account_type === 'punches') {
                                                name = $filter('translate')('type_punches');
                                            }
                                            if (special.special_account_type === 'money') {
                                                name = $filter('translate')('type_money');
                                            }
                                            if (special.special_account_type === 'goods') {
                                                name = $filter('translate')('type_goods');
                                            }
                                            b = name;
                                        }

                                    } else {
                                        b = '';
                                    }
                                    break;

                                case 'special_balance':
                                    if (tl[i].specials && tl[i].specials.length > 0) {
                                        var spec = tl[i].specials.find(function (el) {
                                            return el.special_account_id === export_struct[k].id
                                        });
                                        b = spec && spec.balance ? spec.balance : '';
                                    } else {
                                        b = '';
                                    }
                                    break;

                                case 'special_currency':
                                    if (tl[i].specials && tl[i].specials.length > 0) {
                                        var spec = tl[i].specials.find(function (el) {
                                            return el.special_account_id === export_struct[k].id
                                        });
                                        b = spec ? export_struct[k].currency : '';
                                    } else {
                                        b = '';
                                    }
                                    break;
                                case 'special_extended':
                                    if (tl[i].specials && tl[i].specials.length > 0) {
                                        var spec = tl[i].specials.find(function (el) {
                                            return el.special_account_id === export_struct[k].id
                                        });
                                        b = spec && (spec.extended !== 0 && spec.extended !== null) ? $filter('translate')('Yes') : $filter('translate')('No');
                                    } else {
                                        b = '';
                                    }
                                    break;

                                default:
                                    b = export_struct[k].value && tl[i] && tl[i][export_struct[k].value] ? $filter('translate')(tl[i][export_struct[k].value]) : '';
                            }

                            // customer fields
                            if (/^bcf_(.*)_value/.test(export_struct[k].value)) {
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                            }

                            if (/^qf_(.*)_value/.test(export_struct[k].value)) {
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                            }

                            el[a] = b;
                        } catch (e) {
                            console.log('Error with field export ', e)
                        }
                    }
                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                    block_clients_list.stop();
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }

            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.summary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getCustomers(exportParams[currentPage]).then(function (resp) {
                        if (resp.data && resp.data.length > 0 && hasSpacialAccounts) {
                            var dataToExport = []
                            resp.data.forEach(function (el, i) {
                                getSpecialAccountsByCustomer(el.user_id).then(function (data) {
                                    el.specials = data;
                                    dataToExport.push(el)
                                    if (i === resp.data.length - 1) {
                                        var arr = {
                                            data: dataToExport,
                                            summary: resp.summary
                                        }
                                        exportValues = [...exportValues, arr];
                                        currentPage++;
                                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.summary.total_rows_count);
                                        if (!isExportStopped
                                            && !$scope.exportModal.isExportPaused
                                            && exportParams[currentPage]) {
                                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                                resolve(response);
                                            });
                                        } else {
                                            resolve({currentPage: currentPage});
                                        }
                                    }
                                })

                            })
                        } else {
                            exportValues = [...exportValues, resp];
                            currentPage++;
                            ExportService.calculateExportValuesCount($scope, exportValues, $scope.summary.total_rows_count);
                            if (!isExportStopped
                                && !$scope.exportModal.isExportPaused
                                && exportParams[currentPage]) {
                                downloadNextPage(exportParams, currentPage).then(function (response) {
                                    resolve(response);
                                });
                            } else {
                                resolve({currentPage: currentPage});
                            }
                        }

                    });
                });
            }

            function getCustomers(params) {
                return new Promise(function (resolve) {
                    CustomerService.All(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            function getSpecialAccountsByCustomer(user_id) {
                return new Promise(function (resolve) {
                    CustomerService.GetCustomerSpecialAccounts(user_id, function (success, data) {
                        resolve(data);
                    })
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;
                tl.forEach(function (item) {
                    item.id = item.user_id;
                });
                generateFile();
            }

            exportRequest();
        };

        /**
         * Check if modification user data is denied
         */
        function isModifyDenied() {
            if (isPageMode('edit') && !$rootScope.ENV.business.status.platform_allow_business_change_existing_users) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * Check if consent exist
         */
        function isConsentExist() {
            if ($scope.model.consent_exist) {
                return true;
            } else {
                return false;
            }
        }

        function getCustomerStatusDescription(status) {
            var res;
            switch (status) {
                case 'active':
                    res = 'TEXT_CUSTOMER_STATUS_ACTIVE';
                    break;
                case 'registered':
                    res = 'TEXT_CUSTOMER_STATUS_REGISTERED';
                    break;
                case 'suspended':
                    res = 'TEXT_CUSTOMER_STATUS_SUSPENDED';
                    break;
                case 'banned':
                    res = 'TEXT_CUSTOMER_STATUS_BANNED';
                    break;
                default:
                    res = '-';
            }
            return res;
        }
    }

})();
